import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface EmailAccount {
  id: number
  uuid: string
  user_id: number
  provider: string
  email_address: string
  display_name: string
  created_at: string
  last_sync: string | null
  is_active: boolean
  needs_reauth: boolean
  warmup_enabled: boolean
  daily_send_limit: number
  emails_sent_today: number

  // New settings/observability (SMTP/IMAP hardening)
  hourly_sending_limit?: number
  send_window_enabled?: boolean
  send_window_tz?: string
  send_window_start_hour?: number | null
  send_window_end_hour?: number | null

  account_health_status?: string
  connection_status?: string

  failure_streak?: number
  last_failure_at?: string | null
  last_failure_class?: string | null
  cooldown_until?: string | null
}

interface EmailAccountState {
  accounts: EmailAccount[]
  currentAccount: EmailAccount | null
  isLoading: boolean
  error: string | null
}

const initialState: EmailAccountState = {
  accounts: [],
  currentAccount: null,
  isLoading: false,
  error: null,
}

const emailAccountSlice = createSlice({
  name: 'emailAccounts',
  initialState,
  reducers: {
    setAccounts: (state, action: PayloadAction<EmailAccount[]>) => {
      state.accounts = action.payload
    },
    addAccount: (state, action: PayloadAction<EmailAccount>) => {
      state.accounts.push(action.payload)
    },
    updateAccount: (state, action: PayloadAction<EmailAccount>) => {
      const index = state.accounts.findIndex(a => a.id === action.payload.id)
      if (index !== -1) {
        state.accounts[index] = action.payload
      }
    },
    deleteAccount: (state, action: PayloadAction<number>) => {
      state.accounts = state.accounts.filter(a => a.id !== action.payload)
    },
    setCurrentAccount: (state, action: PayloadAction<EmailAccount | null>) => {
      state.currentAccount = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
  },
})

export const {
  setAccounts,
  addAccount,
  updateAccount,
  deleteAccount,
  setCurrentAccount,
  setLoading,
  setError,
} = emailAccountSlice.actions

export default emailAccountSlice.reducer 